(function () {
    'use strict';

    angular
            .module('imnApp')
            .controller('LoginController', LoginController);

    LoginController.$inject = ['$scope', '$state', 'LoginService', 'UserData', 'Authenticate', '$timeout', 'RequestService'];

    function LoginController($scope, $state, LoginService, UserData, Authenticate, $timeout, RequestService) {

        var vm = this;

        vm.requestRunning = true;
        vm.desabilitaButtonLogin = true;
        vm.account = null;
        vm.isAuthenticated = null;
        vm.credentials = {username: '', password: ''};

        vm.init = init;


        vm.login = function () {
            LoginService.login(vm.credentials).then(successLogin).catch(errorLogin);
        }

        vm.recoverPassword = function () {
            LoginService.recoverLoginModalConstructor();
        }

        function successLogin(data) {
            UserData.getCurrentUser().then(function (data) {
                $state.go('olt').then(function () {
                    if (data.notifications.pwdChanged === true) {
                        LoginService.alertNotificationModalConstructor('passwordChanged');
                    }
                    if (data.notifications.lastSystemBackupOk === false) {
                        LoginService.alertNotificationModalConstructor('backupFailed');
                    }
                });
            });
        }

        function errorLogin(response) {
            LoginService.errorModalConstructor(response, 'authentication');
        }

        vm.supportLogin = function () {
            LoginService.supportLoginModalConstructor();
        }

        function setRequestStart() {
            vm.requestRunning = true;
        }

        function setRequestEnd() {
            vm.requestRunning = false;
        }

        function init() {
            
            setRequestStart();

            fetch(RequestService.baseUrl('swagger-ui.html')).then(function (response) {
                console.log("swagger - response: ", response);
                vm.desabilitaButtonLogin = false;
                setRequestEnd();
                $scope.$apply();
                $timeout(init, 360000);
            }).catch(function (err) {
                console.log("Something went wrong!", err);
                vm.desabilitaButtonLogin = true;
                $timeout(init, 2000);
            });
        }

        init();

    }
})();